import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { getLabel } from '@/helpers/Utils';

export const fetchManager = createAsyncThunk(
  'manager/fetchManager',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetAllManagers();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label:
            item?.employeeWorkDetails?.employeeNo +
            ' | ' +
            getLabel(item.nameAr, item.nameEn),
          value: item.id,
        })) ?? [];
      return [...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  managerList: [],
  loading: false,
  error: '',
};

const managerSlice = createSlice({
  name: 'manager',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchManager.fulfilled, (state, action) => {
        state.loading = false;
        state.managerList = action.payload;
        state.error = '';
      })
      .addCase(fetchManager.rejected, (state, action) => {
        state.loading = false;
        state.managerList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default managerSlice.reducer;
